import { strictEmailValidation } from "../../constants/validityPatterns";

export default function strictValidateEmail(email) {
    return strictEmailValidation.test(String(email).toLowerCase());
}
